import React, { useState, useRef } from "react";
import styles from "../../styles/components/filters.module.scss";
import Icons from "../../public/assets/svg";
import DropDown from "../listWithoutcheck";
import endpoints from "../../utility/endpoints";
import axios from "axios";
import { saveBotsAction, getBotsAction } from "../../redux/storeBot/actions";
import { useDispatch } from "react-redux";
import { Router, useRouter } from "next/router";
import _ from "lodash";

export default function index(props) {

 
const inputRef = useRef(null)
 // console.log(props, "props at the start ");
  const {
    data: {
      field_label,
      field_title,

      field_bot_store_filters_fields,
    },
  } = props;

  const router = useRouter();
  const dispatch = useDispatch();
  // to convert labels into camelcase
  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  // saving bots camalcased label as value
  field_bot_store_filters_fields.map((item) => {
    item.value = camelize(item.field_label);
  });

  let dropDownsInitialStates = {};

  field_bot_store_filters_fields.map((item) => {
    if (item.field_label != "Search") {
      props.initialStates[camelize(item.field_label)] = "";
    }

    if (
      item.field_input_type == "Dropdown" ||
      item.field_input_type == "Related Dropdown"
    ) {
      dropDownsInitialStates[camelize(item.field_label)] = false;
    }
  });

  React.useEffect(() => {
    let relatedDropdownToSet = {};
    field_bot_store_filters_fields.map((item) => {
      if (item.field_input_type == "Related Dropdown") {
        relatedDropdownToSet[camelize(item.field_label)] =
          item.field_dropdown_option_component;
      }
    });

    setRelatedDropdowns(relatedDropdownToSet);
  if (props.state.search && props.state.search.length > 0) {
    inputRef.current.focus()
  }
    
  }, []);

  const [admin, setadmin] = useState(false);
  const [relatedDropdowns, setRelatedDropdowns] = React.useState(null);
  const [dropDownState, setDropdownState] = React.useState(
    dropDownsInitialStates
  );





  const [reload, setReload] = useState(false);
  const [search, setSearch ] = useState(props.state.search)


  React.useEffect(() => {
    if(reload) {   
      props.setState({ ...props.state, ["search"]: search });
      
   }
  }, [reload]);

  const callApi = () => { setReload(true) }; // You might be able to call API directly here, I haven't tried
  const [debouncedCallApi] = useState(() => _.debounce(callApi, 300));

  const inputChange = (e) => {
    if (e.target.value.length == 0) {
      //  console.log(e.target.value, "before");
      let statess = props.state;
      delete statess.search;
      props.setState({...statess})
      if (_.isEmpty(statess)) {
        props.clearALLFilter();
      }
    } else {
    //  console.log(e.target.value)
    setSearch( e.target.value)
    debouncedCallApi()
    
    }
  };

  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownsInitialStates,
      [item]: !dropDownState[item],
    });
  };

  const gotDropDownValue = (value, dropdownParent, haveRelated) => {

    let stateToChange = props.state
    if (haveRelated) {
      const relatedDropdown = relatedDropdowns[haveRelated];


      relatedDropdown.nowValues = relatedDropdowns[haveRelated].filter(
        (item) => item.field_title == value
      )[0].field_options;

      setRelatedDropdowns({
        ...relatedDropdowns,
        [haveRelated]: relatedDropdown,
      });
      
      
      delete stateToChange[haveRelated]
      let ChildObj = props.data.field_bot_store_filters_fields.filter((item)=>item.value == haveRelated)
     
      let grandChildren = camelize(ChildObj[0].field_related_dropdown)
      if(grandChildren){
        let realll = relatedDropdowns
        delete realll[grandChildren].nowValues
        setRelatedDropdowns({...realll})
    }
  }



    setDropdownState(dropDownsInitialStates);
    props.setState({ ...stateToChange, [dropdownParent]: value });
   // props.getFilterValue(value);
  };



  const clearAllFilters = () => {
    props.setState({});
    setDropdownState(dropDownsInitialStates);
    // dispatch(getBotsAction(0));
    props.clearALLFilter();
    props.setReset(true)
  };
         
  React.useEffect(()=>{
    if(props.reset){
      props.setReset(false)
      let reall = relatedDropdowns;
      for(let i in reall){
        delete reall[i].nowValues
      }
      setRelatedDropdowns({...reall})
    }

  },[props.reset])

  React.useEffect(() => {
  //  console.log(router.query, "all kinda queries");
    delete router.query.path;
   // console.log(props.state, "state at route query");
    //setState(...state, ...router.query);
  }, [router.query]);


  const closeAllDropdowns = () => {
    setDropdownState(dropDownsInitialStates)
  }

  return (
    <div className={styles.filtersWrapper}>
    <div className={styles.filtersContent}>
      <div className={styles.head}>
        <div className={styles.left}>
          <span>{field_title}</span>
        </div>
        <div className={styles.right} onClick={clearAllFilters}>
          <span className={styles.more}>{field_label}</span>
        </div>
      </div>
      <div className={styles.listWrapper}>
        {field_bot_store_filters_fields.map((item, index) => {
          if (item.field_input_type == "Radio") {
            return (
              <div className={styles.formGroup} onChange={inputChange}>
                <label className={styles.mainLabel}>
                  {item.field_label}
                  <sup className={styles.mandatoryField}>*</sup>
                </label>
                <div className={styles.inputGroupWrapper}>
                  {item.field_options.map((radioItem, index) => (
                    <label className={styles.radioWrapper} key={index}>
                      <span className={styles.subLabel}>{radioItem}</span>
                      <input
                        type="radio"
                        className={styles.radioBox}
                        value={camelize(radioItem)}
                        name={item.value}
                      />
                      <span className={styles.radioCheckmark}></span>
                    </label>
                  ))}
                </div>
              </div>
            );
          } else if (item.field_input_type == "Plain Text") {
            return (
              <div className={`${styles.inputGroup} `}>
                <label>
                  <span>
                    {item.field_label}
                   
                  </span>
                </label>
                <p className={`${styles.input}`}>
                  <input className={styles.inputText}
                    type="text"
                    placeholder={item.field_title}
                    name={item.value}
                    onChange={inputChange}
                    value = {search ? search : ""}
                    ref = {inputRef}
                  />
                   
                </p>
              </div>
            );
          } else if (
            item.field_input_type == "Dropdown" ||
            item.field_input_type == "Related Dropdown"
            
          )
           {

            if (item.value == "area" && !props.state.leadPlatform){
              return null
            }
           // console.log(props.state[item.value], "inside filter")
            return (
              <div className={styles.inputGroup}>
                <label>
                  <span>{item.field_label}</span>
                </label>
                <p
                  className={`${styles.input}`}
                  onClick={() => {
                    handleDropDown(item.value);
                  }}
                >
                  <span className={styles.left}>
                    {props.state[item.value] == null || props.state[item.value] === undefined || props.state[item.value].length == 0
                      ? item.field_input
                      : props.state[item.value]}
                  </span>
                  <span className={styles.right}>
                    <Icons name="chevron" className={styles.chevron} />
                  </span>
                </p>
                {dropDownState[item.value] == true ? (
                  <DropDown
                    dropdownParent={item.value}
                    closeAllDropdowns={closeAllDropdowns}
                    params = "botStoreFilters"
                    values={
                      item.field_input_type == "Related Dropdown"
                        ? relatedDropdowns[item.value].nowValues != undefined
                          ? relatedDropdowns[camelize(item.field_label)]
                              .nowValues
                          : ["No parent Selected"]
                        : item.field_options
                    }
                    getDropdownValue={gotDropDownValue}
                    haveRelated={camelize(item.field_related_dropdown)}
                  />
                ) : null}
              </div>
            );
          }
        })}

      
      </div>
    </div>
    </div>
  );
}
